// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionBorder_container__3udYp","white":"SectionBorder_white__2aR2V","gray":"SectionBorder_gray__2zvhf","placeholderShimmer":"SectionBorder_placeholderShimmer__2ry3o"};